module.exports = __webpack_public_path__ + "img/example-right.d76e0c18.webp";